import axios from "axios";
import { Outlet } from "react-router-dom";
import { GlobalState } from "./GlobalContext";
import React, { createContext, useContext, useEffect, useState } from "react";

const ShippingProviderRecoContext = createContext();

const ShippingProviderRecoProvider = ({ children }) => {
	const { snackbar, setSnackBar, setSnackBarOpen } = GlobalState();

	const [allStores, setAllStores] = useState();
	const [itemMastDropdownsList, setItemMastDropdownsList] = useState([]);
	const [allWarehouses, setAllWarehouses] = useState();

	const fetch = async () => {
		try {
			await axios.get(`/api/item_master/get_distinct_im_main_fields`).then((res) => {
				setItemMastDropdownsList(res.data?.result);
			});
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackbar,
				message: "Unable to fetch  Attributes",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	useEffect(() => {
		// fetchAllStores();
		// fetch();
		// fetchWarehouses();
	}, []);

	return (
		<ShippingProviderRecoContext.Provider
			value={{
				allStores,
				setAllStores,
				itemMastDropdownsList,
				allWarehouses,
			}}>
			<Outlet />
		</ShippingProviderRecoContext.Provider>
	);
};

export const ShippingProviderRecoState = () => {
	return useContext(ShippingProviderRecoContext);
};

export default ShippingProviderRecoProvider;
